import { createAsyncSlice } from 'store/createAsyncSlice';
import { saveTaxCertificationsAsync } from '../../../API/taxCertifications/saveTaxCertificationAsync';

export const { slice: saveTaxCertificationsSlice, asyncAction: saveTaxCertificationsAsyncAction } = createAsyncSlice(
  'saveTaxCertificationSlice',
  saveTaxCertificationsAsync
);
